/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { TextField } from "@mui/material";
import LabelledField from "components/labelled-field";
import { ImageSelector } from "cms/images/image-selector";
import LinkSelector from "cms/links/link-selector";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";


const TestimonialHighlightComponentEditor = () => {
    const { component, update } = useUpdateComponent();


    const title = component.title;
    const description = component.description;
    const image = component.image;
    const company_logo = component.company_logo;
    const testimonial_quote = component.testimonial_quote;
    const person_image = component.person_image;
    const person_name = component.person_name;
    const person_title = component.person_title;
    const person_company = component.person_company;
    const link = component.link;

    const onChangeTitle = (event) => {
        const title = event.target.value;
        update("title", title);
    };
    const onChangeDescription = (event) => {
        const description = event.target.value;
        update("description", description);
    };
    const onChangeImage = (image) => {
        update("image", image);
    };
    const onChangeCompanyLogo = (company_logo) => {
        update("company_logo", company_logo);
    };
    const onChangeTestimonialQuote = (richtext) => {
        update("testimonial_quote", richtext);
    };
    const onChangePersonImage = (person_image) => {
        update("person_image", person_image);
    };
    const onChangePersonName = (event) => {
        const person_name = event.target.value;
        update("person_name", person_name);
    };
    const onChangePersonTitle = (event) => {
        const person_title = event.target.value;
        update("person_title", person_title);
    };
    const onChangePersonCompany = (event) => {
        const person_company = event.target.value;
        update("person_company", person_company);
    };
    const onChangeLink = (link) => {
        update("link", link);
    };

    return (
        <div className="testimonial-highlight-editor-frame">
            <LabelledField label="Title">
                <TextField
                    id="testimonial_highlight_title"
                    fullWidth={true}
                    value={title}
                    placeholder="Add a title"
                    onChange={onChangeTitle}
                />
            </LabelledField>
            <LabelledField label="Description">
                <TextField
                    id="testimonial_highlight_description"
                    fullWidth={true}
                    value={description}
                    placeholder="Add a description"
                    onChange={onChangeDescription}
                />
            </LabelledField>
            <LabelledField label="Main Image">
                <div className="testimonial-highlight-image-selector">
                    <ImageSelector
                        image={image}
                        setImage={onChangeImage}
                        onSelectImage={onChangeImage}
                        onSaveImage={onChangeImage}
                        onImageRemoved={() => onChangeImage(null)}
                        onImageDeleted={() => onChangeImage(null)}
                        onReload={() => {}}
                    />
                </div>
            </LabelledField>
            <LabelledField label="Company Logo">
                <div className="testimonial-highlight-company-logo-selector">
                    <ImageSelector
                        image={company_logo}
                        setImage={onChangeCompanyLogo}
                        onSelectImage={onChangeCompanyLogo}
                        onSaveImage={onChangeCompanyLogo}
                        onImageRemoved={() => onChangeCompanyLogo(null)}
                        onImageDeleted={() => onChangeCompanyLogo(null)}
                        onReload={() => {}}
                    />
                </div>
            </LabelledField>
            <LabelledField label="Testimonial Quote">
                <div className="testimonial-highlight-quote-editor">
                    <SimplicityComposerEnsureTipTap
                        richtext={testimonial_quote}
                        onChange={onChangeTestimonialQuote}
                    />
                </div>
            </LabelledField>
            <LabelledField label="Person Image">
                <div className="testimonial-highlight-person-image-selector">
                    <ImageSelector
                        image={person_image}
                        setImage={onChangePersonImage}
                        onSelectImage={onChangePersonImage}
                        onSaveImage={onChangePersonImage}
                        onImageRemoved={() => onChangePersonImage(null)}
                        onImageDeleted={() => onChangePersonImage(null)}
                        onReload={() => {}}
                    />
                </div>
            </LabelledField>
            <LabelledField label="Person Name">
                <TextField
                    id="testimonial_highlight_person_name"
                    fullWidth={true}
                    value={person_name}
                    placeholder="Add a person name"
                    onChange={onChangePersonName}
                />
            </LabelledField>
            <LabelledField label="Person Title">
                <TextField
                    id="testimonial_highlight_person_title"
                    fullWidth={true}
                    value={person_title}
                    placeholder="Add a person title"
                    onChange={onChangePersonTitle}
                />
            </LabelledField>
            <LabelledField label="Person Company">
                <TextField
                    id="testimonial_highlight_person_company"
                    fullWidth={true}
                    value={person_company}
                    placeholder="Add a person company"
                    onChange={onChangePersonCompany}
                />
            </LabelledField>
            <LabelledField label="Link">
                <div className="testimonial-highlight-link-selector">
                    <LinkSelector
                        link={link}
                        setLink={onChangeLink}
                        onSelectLink={onChangeLink}
                        onLinkRemoved={() => onChangeLink(null)}
                    />
                </div>
            </LabelledField>
        </div>
    );
};

export { TestimonialHighlightComponentEditor }; 